import { CommonModule } from '@angular/common';
import { Component, forwardRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { UsersService } from '../../../../core/services/users.service';
import { User } from '../../../../core/models/user.interface';
import { ConfigurationService } from '../../../../core/services/configuration.service';
import { BaseComponent } from '../../../../core/shared/base.component';
import { LoaderService } from '../../../../core/shared/services/loader.service';
import { GenericToggleSwitchComponent } from '../../../../core/shared/components/switch/generic-toggle-switch.component';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-users-assigned-permissions',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, GenericToggleSwitchComponent],
  templateUrl: './users-assigned-permissions.component.html',
  styleUrl: './users-assigned-permissions.component.scss'
})
export class UsersAssignedPermissionsComponent extends BaseComponent implements OnInit {

  private authService = inject(AuthService);
  private authUser = this.authService.getAuthUser();
  private configurationService = inject(ConfigurationService);
  private usersService = inject(UsersService);
  private loader = inject(LoaderService);
  @Input()
  user?: User;
  permissionsDefault: any[] = [];
  permissions: any[] = [];

  ngOnInit(): void {
    if (!this.user) return;

    console.log('ngOnInit called with user:', this.user);

    if (!this.user?.permissions || this.user?.permissions.length == 0) {
      this.loader.show();
      this.configurationService.getCustomerPermissions().subscribe({
        next: (res) => {
          this.permissions = res.data;
          this.permissions.forEach(permission => {
            permission.status = 'Desactivado';
            permission.active = false;
          });
          this.loader.hide();
        },
        error: (error) => {
          console.error('Error al obtener permisos:', error);
          this.loader.hide();
        }
      });
    } else {
      this.permissions = this.user.permissions;
    }
  }

  save() {
    this.loader.show();
    console.log('Guardando permisos para el usuario:', this.user, this.permissions);
    this.usersService.updatePermissions(this.user!._id, this.permissions).subscribe({
      next: (res) => {
        this.success('Permisos actualizados correctamente');
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error al obtener permisos:', error);
        this.error('Error al actualizar permisos. Vuelva a intentarlo más tarde.');
        this.loader.hide();
      }
    });
  }

  view(item: any) {
    console.log('Ver permisos de usuario:', item);
  }

  changeActive(active: boolean, item: any) {
    item.status = item.active ? 'Activado' : 'Desactivado';
    this.save();
  }

}
